import React from 'react';

import { Slide } from 'react-slideshow-image';

import img1 from '../assets/photoWho.jpg';
import img2 from '../assets/fertilizzanti.jpg';
import img3 from '../assets/Where3.jpeg';



const slideImages = [
  img1,
  img2,
  img3
];

const properties = {
  duration: 4000,
  transitionDuration: 500,
  infinite: true,
  indicators: true,
  arrows: false,
}


const Slideshow = () => {
  return (

              <Slide {...properties}>
                <div className="each-slide">
                  <img src={slideImages[0]} alt="Proprietari di Botanica urbana Senago" title="Albi e Nico" />
                </div>
                <div className="each-slide">
                  <img src={slideImages[1]} alt="prodotti per la coltivazione indoor"  title="fertilizzanti"/>
                </div>

                <div className="each-slide">
                  <img src={slideImages[2]} alt="botanica urbana senago" title="Botanica Urbana Senago"/>
                </div>
              </Slide>

  )
}

export default Slideshow;
